export default function GraphqlError(error) {
  const graphqlError = Error(error.message);
  graphqlError.name = 'GraphQL';

  return graphqlError;
}
